const app = Vue.createApp({
  delimiters: ['[[', ']]'],
  data() {
    return {
      stocks: [],
      famousList: [],
      faq: [
        { title: "会員登録について", id:2, list: [] },
        { title: "ご注文・お支払い方法について", id:4, list: [] },
        { title: "商品について", id:3, list: [] },
        { title: "送料・配送について", id:5, list: [] },
        { title: "キャンセル・返品・交換について", id:6, list: [] },
        { title: "KUMASUNについて", id:26, list: [] },
        { title: "その他", id:7, list: [] }
      ],
      fetches:0
    };
  },
  computed: {
    loaded(){
      if(this.fetches >= 2){
        return true;
      }
    },
    famous() {
      var arr = [];
      this.famousList.forEach(item => {
        var a = this.getFaqByLink(this.faq, item);
        if (a) {
          arr.push(a);
        }
      });
      return arr;
    }
  },
  created() {
    this.faq_load();
    this.famous_load();
  },
  methods: {
    getFaqByLink(arr, number) {
      for (var i = 0; i < arr.length; i++) {
        for (var j = 0; j < arr[i].list.length; j++) {
          if (arr[i].list[j].id === number) {
            return { title: arr[i].list[j].title, id: arr[i].list[j].id };
          }
        }
      }
      return null;
    },
    faq_load() {
      //1度目のアクセスでfetchしたデータをセッションストレージに保存。
      //保存日時も保存する。
      //2度目以降のアクセス時は、保存時間から2分が経過していた場合は再度fetchし、2分以内であればセッションストレージからデータを利用する。
      var that = this;
      var storedFaq = sessionStorage.getItem('storedFaq');
      var storedTime = sessionStorage.getItem('storedTime');
      if (storedFaq && storedTime) {
        var currentTime = new Date().getTime();
        if ((currentTime - storedTime) < 120000) { // 2 minutes in milliseconds
          this.faq = JSON.parse(storedFaq);
          this.fetches ++;
          setTimeout(()=>{setEqualHeight();},50);
          return;
        }
      }

      fetch('https://ec.kumanomae.co.jp/wp/wp-json/wp/v2/faq?_embed&per_page=300')
        .then(response => response.json())
        .then(posts => {
          var faq = [];
          posts.forEach(item => {
            var categoryId = item.faq_category;
            var faqItem = {
              title: item.title.rendered,
              id: item.id,
            };
            addValueToFaq(this.faq, categoryId, faqItem);
          });
          this.fetches ++;
          setTimeout(()=>{setEqualHeight();},50);

          sessionStorage.setItem('storedFaq', JSON.stringify(this.faq));
          sessionStorage.setItem('storedTime', new Date().getTime());
        })
        .catch(error => {
          console.error('Error fetching faq:', error);
        });
    },
    famous_load() {
      //1度目のアクセスでfetchしたデータをセッションストレージに保存。
      //保存日時も保存する。
      //2度目以降のアクセス時は、保存時間から2分が経過していた場合は再度fetchし、2分以内であればセッションストレージからデータを利用する。
      var storedFamous = sessionStorage.getItem('storedFamous');
      var storedTime = sessionStorage.getItem('storedFamousTime');
      if (storedFamous && storedTime) {
        var currentTime = new Date().getTime();
        if ((currentTime - storedTime) < 120000) { // 2 minutes in milliseconds
          this.famousList = JSON.parse(storedFamous);
          this.fetches ++;
          return;
        }
      }

      fetch('https://ec.kumanomae.co.jp/wp/wp-json/wp/v2/faq_famous?_embed')
        .then(response => response.json())
        .then(posts => {
          posts.forEach(item => {
            if (item.acf.cf_faq_famous) {
              this.famousList = item.acf.cf_faq_famous;
            }
          });
          this.fetches ++;
          sessionStorage.setItem('storedFamous', JSON.stringify(this.famousList));
          sessionStorage.setItem('storedFamousTime', new Date().getTime());
        })
        .catch(error => {
          console.error('Error fetching famous:', error);
        });
    }
  }
});

const vm = app.mount("#faq");

function addValueToFaq(faq, catId, value) {
  for (var i = 0; i < faq.length; i++) {
    if (faq[i].id == catId) {
      faq[i].list.push(value);
      return;
    }
  }
}


window.addEventListener('load', setEqualHeight);
window.addEventListener('resize', setEqualHeight);

function setEqualHeight() {
    if (window.innerWidth >= 768) { // PCデバイスの場合
        const cols = document.querySelectorAll('.p-contents__col');
        cols.forEach((col, index) => {
            // 奇数インデックス（0-based）の.colに対して処理
            if (index % 2 === 0 && index < cols.length - 1) {
                const nextCol = cols[index + 1];

                // 現在の.colと次の.colの.p-contents__listを取得
                const currentLists = col.querySelectorAll('.p-contents__list');
                const nextLists = nextCol.querySelectorAll('.p-contents__list');
                
                // 両方のリストの高さを取得
                let currentMaxHeight = 0;
                let nextMaxHeight = 0;
                
                currentLists.forEach(list => {
                    list.style.height = 'auto'; // 初期化
                    currentMaxHeight = Math.max(currentMaxHeight, list.clientHeight);
                });
                
                nextLists.forEach(list => {
                    list.style.height = 'auto'; // 初期化
                    nextMaxHeight = Math.max(nextMaxHeight, list.clientHeight);
                });

                // 高さを揃える
                const maxHeight = Math.max(currentMaxHeight, nextMaxHeight);
                currentLists.forEach(list => {
                    list.style.height = `${maxHeight}px`;
                });

                nextLists.forEach(list => {
                    list.style.height = `${maxHeight}px`;
                });
            }
        });
    } else {
        // モバイルなどPC以外のデバイスでは高さを自動で調整する
        const lists = document.querySelectorAll('.p-contents__list');
        lists.forEach(list => {
            list.style.height = 'auto';
        });
    }
}